var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default panel-top-bordered"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body text-center"},[_c('canvas',{ref:"chart",attrs:{"width":"800","height":"250"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-heading"},[_c('h5',[_vm._v("\n      Page Views\n    ")])])
}]

export { render, staticRenderFns }